var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        ref: "table",
        staticClass: "q-mt-lg",
        attrs: {
          data: _vm.data,
          columns: _vm.columns,
          "row-key": "id",
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.request
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.$t(col.label)) + "\n\t\t\t\t"
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return [
                _c(
                  "q-tr",
                  { attrs: { props: props } },
                  [
                    _c("q-td", { key: "drill_id", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(props.row.drill_id) +
                          "\n\t\t\t\t\t"
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "drill_title", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(props.row.drill_title) +
                            "\n\t\t\t\t\t"
                        )
                      ]
                    ),
                    _c("q-td", { key: "score", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(props.row.score.toFixed(2)) +
                          "\n\t\t\t\t\t"
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "result_date", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.getDateFormated(props.row.result_date)) +
                            "\n\t\t\t\t\t"
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      {
                        key: "status",
                        attrs: { props: props, "auto-width": "" }
                      },
                      [
                        _c(
                          "q-chip",
                          {
                            attrs: {
                              small: "",
                              color: _vm.getColorStatus(props.row.status)
                            }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t(_vm.getStatus(props.row.status))
                                ) +
                                "\n                        "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "q-td",
                      {
                        key: "published",
                        attrs: { props: props, "auto-width": "" }
                      },
                      [
                        _c(
                          "q-chip",
                          {
                            attrs: {
                              small: "",
                              color: _vm.getColorDrillStatus(
                                props.row.drill_status
                              )
                            }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.getDrillStatus(props.row.drill_status)
                                  )
                                ) +
                                "\n                        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c("certificate", {
        attrs: { show: _vm.show_certificate, data: _vm.certificate_data },
        on: { hideCertificate: _vm.hideCertificate }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }